// Overview VoltaGrid — the Overview page for the VoltaGrid jobs (the list in
// helpers/voltaGrid). It renders the standard Overview as-is, reading and saving the
// same 'Overview' rows, so the two tabs never drift apart; the VoltaGrid-only
// sections get added here (or behind `variant === 'voltagrid'` in overview.js
// when they have to sit inside the page's own layout).
import React from 'react';
import Overview from './overview';

function OverviewVoltaGrid() {
    return <Overview variant="voltagrid" />;
}

export default OverviewVoltaGrid;
